module.exports = __webpack_public_path__ + "img/pellets-bigbag-yellow.1450732.svg";